import type { ReactNode } from 'react';
import { Box } from '../box/box';
import { BlockStack } from '../block-stack/block-stack';
import { InlineStack } from '../inline-stack/inline-stack';
import { Typography } from '../typography/typography';

export interface PageHeaderProps {
    title: string;
    description?: string;
    /** Right-aligned actions (buttons, menus). */
    actions?: ReactNode;
    testID?: string;
}

/** Page title block with optional description, trailing actions and a divider. */
export function PageHeader({ title, description, actions, testID }: PageHeaderProps) {
    return (
        <Box
            paddingBlockEnd="500"
            borderColor="border-card"
            borderBlockEndWidth="0165"
            testID={testID}
        >
            <InlineStack align="space-between" blockAlign="start" gap="400">
                <BlockStack gap="100">
                    <Typography variant="heading-xl" as="h1" fontWeight="semibold">
                        {title}
                    </Typography>
                    {description ? (
                        <Typography variant="body-md" tone="text-secondary">
                            {description}
                        </Typography>
                    ) : null}
                </BlockStack>
                {actions ? <InlineStack gap="200">{actions}</InlineStack> : null}
            </InlineStack>
        </Box>
    );
}
